module.exports = __webpack_public_path__ + "img/1.e3528786.png";